var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBusiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 9.667H3.833c-.466 0-.7 0-.878.09a.833.833 0 0 0-.364.365c-.09.178-.09.411-.09.878v7m11.25-8.333h2.416c.466 0 .7 0 .878.09.157.08.284.208.364.365.091.178.091.411.091.878v7m-3.75 0V5.667c0-.934 0-1.4-.182-1.757a1.667 1.667 0 0 0-.728-.728C12.483 3 12.017 3 11.083 3H8.917c-.934 0-1.4 0-1.757.182-.314.16-.568.414-.728.728-.182.357-.182.823-.182 1.757V18m12.083 0H1.667m7.5-11.667h1.666M9.167 9.667h1.666M9.167 13h1.666",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBusiness;